import { useState } from "react";
import { Button } from "../components/button";
import { Textarea } from "../components/textarea";

type Props = {
  caps: { can_comment: boolean };
  onSubmit: (body: string) => Promise<void>;
  onError: (message: string) => void;
  placeholder?: string;
  maxLength?: number;
};

export function CommentComposer({
  caps,
  onSubmit,
  onError,
  placeholder = "Yorum yazın…",
  maxLength = 4000,
}: Props) {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);

  if (!caps.can_comment) return null;

  const trimmed = value.trim();
  const disabled = busy || trimmed.length === 0 || trimmed.length > maxLength;

  const submit = async () => {
    if (disabled) return;
    setBusy(true);
    try {
      await onSubmit(trimmed);
      setValue("");
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Yorum gönderilemedi";
      onError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <Textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={2}
        className="text-xs min-h-[2.5rem]"
        data-testid="comment-composer-textarea"
        onKeyDown={(e) => {
          if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            void submit();
          }
        }}
      />
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10px] text-muted-foreground">
          {trimmed.length}/{maxLength}
        </span>
        <Button
          size="sm"
          onClick={() => void submit()}
          disabled={disabled}
          data-testid="comment-composer-submit"
        >
          Gönder
        </Button>
      </div>
    </div>
  );
}
